import * as validate from "validate.js";
export class FiltroTarefa {
	dataInicio: Date;
	dataFim: Date;
	carteiraId: number;
	lista: number;
	listaEstrategia: number;
	listaIds: Array<number>;
	listaEstrategiaIds: Array<number>;
	quantidadeExportadoMaiorQue: number;
	quantidadeProcesso: number;
	status: number;
	somenteExecucaoComErro:boolean;
	jornadaId:number;
	rotinaId: number;

	constructor() {

		let atual = new Date();

		this.dataFim = new Date(
			atual.getFullYear(),
			atual.getMonth(),
			atual.getDate(),
			23,
			59
		);
		this.dataInicio = new Date(
			atual.getFullYear(),
			atual.getMonth(),
			atual.getDate()
		);
		this.listaIds = [];
		this.listaEstrategiaIds = [];
	}

	validar() {
		var validacao: any = {
			dataInicio: {
				presence: {
					allowEmpty: false,
					message: "campoObrigatorio"
				},
				dataMenorQue: {
					campo: "dataFim"
				}
			},
			dataFim: {
				presence: {
					allowEmpty: false,
					message: "campoObrigatorio"
				}
			}
		};
		return validate.validate(this, validacao, { fullMessages: false })
	}
}

